import React, { CSSProperties } from 'react';
import { poweredByNarvarString, isotype } from './paths';
import styles from './NarvarLogo.module.css';

interface NarvarLogoProps {
  style?: CSSProperties;
}

const NarvarLogo = ({ style = {} }: NarvarLogoProps) => (
  <span style={{ color: style?.color ?? '#999' }}>
    <svg
      className={styles.narvarLogo}
      style={style}
      fill="currentColor"
      viewBox="0 0 153 24"
    >
      <title>Powered by Narvar</title>
      <path d={poweredByNarvarString} />
      <path d={isotype} />
    </svg>
  </span>
);

export default NarvarLogo;
